
import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import { translate } from 'react-switch-lang'
import { Container } from 'semantic-ui-react'
import QrScanner from 'qr-scanner'

import MyPage from '../../core/components/MyPage'
import LayoutWithHeaderFooter from '../layout/LayoutWithHeaderFooter'
import ViewHeader from '../layout/ViewHeader'
import ViewFooter from '../layout/ViewFooter'
import { cameraFacingMode, cookiesKey } from '../../constant'
import base64 from 'base-64'
import ViewButton from '../../core/view/common/ViewButton'
import ButtonModel from '../../core/model/ButtonModel'

var isReceive = true

let video = null
// let videoContainer = null
let facingMode = cameraFacingMode.ENVIRONMENT
let scanner = null
class ViewScanQRCode extends MyPage {
    constructor(props) {
        super(props)
        this.state.user = this.bCookie.getData(cookiesKey.USER)
        this.state.isLoading = false

        this.state.isLoadingCamera = false
    }

    componentDidMount() {
        this.startQRScan()
    }

    componentWillUnmount() {
        this.stopQRScan()
    }

    startQRScan = () => {
        video = document.getElementById('qr-video');
        // videoContainer = document.getElementById('video-container');
        scanner = new QrScanner(video, result => this.setResult(result), {
            onDecodeError: error => {
                console.log(error)
            },
            // scanRegion: {
            //     x: 0,
            //     y: 0,
            //     width: 200,
            //     height: 200,
            //     downScaledWidth: 200,
            //     downScaledHeight: 200,
            // },
            // highlightScanRegion: true,
            // highlightCodeOutline: true,
            // calculateScanRegion: d => console.log(d),
            highlightScanRegion: true,
            highlightCodeOutline: true,
            maxScansPerSecond: 3,
        });
        isReceive = true
        scanner.start()
    }

    stopQRScan = () => {
        if (!!scanner) {
            scanner.stop()
        }
    }

    setResult = (result, error) => {
        if (!!result && !!result.data && isReceive === true) {
            isReceive = false
            try {
                let texts = result.data.split('/roominfo/')
                if (texts.length > 1) {
                    this.props.history.replace(`/room/view?roomEmail=${encodeURIComponent(base64.decode(texts[1]))}`)
                } else {
                    throw new Error("QR not found")
                }
            } catch (error) {
                isReceive = true
            }
        }
    }

    onSwitchCamera = async () => {
        if (facingMode === cameraFacingMode.ENVIRONMENT) {
            facingMode = cameraFacingMode.USER
        } else {
            facingMode = cameraFacingMode.ENVIRONMENT
        }
        if (!!scanner) {
            await scanner.setCamera(facingMode)
            await scanner.hasFlash()
        }
    }

    render() {
        const { t } = this.props
        const { isLoading, isLoadingCamera } = this.state

        return (
            <React.Fragment>
                {super.render()}
                {isLoading && this.getLoadingPage()}
                <LayoutWithHeaderFooter
                    header={<ViewHeader />}
                    footer={<ViewFooter />}
                >
                    <div className="module viewScanQRCode">
                        <Container text>
                            <div className="view-scan-qr-code-header">
                                <h1>{t("common.scanQRCode")}</h1>
                            </div>
                            <div className="view-scan-qr-code-body">
                                <div className="qr-code-camera">
                                    {
                                        isLoadingCamera &&
                                        <div className="box-loading">{this.getLoadingComponent()}</div>
                                    }
                                    <div id="video-container">
                                        <video id="qr-video"></video>
                                    </div>
                                </div>
                                <div className="qr-code-action">
                                    <ViewButton
                                        model={new ButtonModel({
                                            text: t("common.switchCamera"),
                                            onClick: this.onSwitchCamera,
                                            color: "teal",
                                            disabled: isLoadingCamera
                                        })}
                                    />
                                </div>
                            </div>
                        </Container>
                    </div>
                </LayoutWithHeaderFooter>
            </React.Fragment>
        )
    }
}

ViewScanQRCode.defaultProps = {
}

const enhance = compose(
    translate,
    withRouter,
)


export default enhance(ViewScanQRCode)